import { useState } from "react";
import { toast } from "sonner";
import { Heart } from "lucide-react";
import { api, errMsg } from "@/lib/api";

// Sends a one-time heart back to the supporter who wrote a gratitude note
export const HeartBack = ({ id, hearted, name, onDone, testId }) => {
  const [on, setOn] = useState(!!hearted);
  const [busy, setBusy] = useState(false);
  const send = async (e) => {
    e.stopPropagation();
    if (on) return;
    setBusy(true);
    try { await api.post(`/gratitude/${id}/heart`); setOn(true); toast.success(`Heart sent to ${name} 💜`); onDone?.(); }
    catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };
  return (
    <button onClick={send} disabled={busy} aria-pressed={on} aria-label={on ? `You loved ${name}'s note` : `Send ${name} a heart`}
      className={`inline-flex items-center gap-1 text-xs font-semibold rounded-full px-2.5 py-1 transition-colors ${on ? "bg-[#F28FAD]/30 text-[#B23A63]" : "bg-white/60 text-[#5B3F8F] hover:bg-white"}`} data-testid={testId}>
      <Heart size={13} className={on ? "fill-current" : ""} />{on ? "Loved" : "Send a heart"}
    </button>
  );
};
